import React from "react";
import { SkeletonBox, SkeletonText } from "./SkeletonBox";

/**
 * ProfilePageSkeleton - Skeleton matching profileContent.jsx layout
 */

function skeletonElement(className) {
  return function SkeletonElement(props) {
    var mergedClassName = className + (props.className ? " " + props.className : "");
    return <div {...props} className={mergedClassName} />;
  };
}

const ContentWrapper = skeletonElement("legacy-skeleton-profile-content");
const ProfileCard = skeletonElement("legacy-skeleton-profile-card");
const SectionCard = skeletonElement("legacy-skeleton-profile-section");
const UserInfoRow = skeletonElement("legacy-skeleton-inline-row legacy-skeleton-profile-user-row");
const UserInfoCell = skeletonElement("legacy-skeleton-profile-cell");
const Divider = skeletonElement("legacy-skeleton-profile-divider");
const MenuGrid = skeletonElement("legacy-skeleton-profile-menu-grid");
const MenuButtonSkeleton = skeletonElement("legacy-skeleton-profile-menu-button");

function ProfilePageSkeleton() {
  return (
    <ContentWrapper>
      <ProfileCard>
        {/* User Info Section Skeleton */}
        <SectionCard>
          <UserInfoRow>
            {/* Avatar */}
            <UserInfoCell style={{ width: "90px" }}>
              <SkeletonBox width={75} height={75} circle />
            </UserInfoCell>

            {/* Name & Phone */}
            <UserInfoCell style={{ width: "200px" }}>
              <SkeletonText width={120} size="xl" style={{ marginBottom: 8 }} />
              <SkeletonText width={100} size="md" />
            </UserInfoCell>

            {/* Divider */}
            <UserInfoCell style={{ width: "50px" }}>
              <Divider />
            </UserInfoCell>

            {/* Subscription Info */}
            <UserInfoCell style={{ flex: 1 }}>
              <SkeletonText width={180} size="md" style={{ marginBottom: 8 }} />
              <SkeletonText width={100} size="sm" />
            </UserInfoCell>

            {/* QR Code */}
            <UserInfoCell style={{ width: "280px", textAlign: "center" }}>
              <SkeletonText width={100} size="sm" style={{ margin: "0 auto 12px" }} />
              <SkeletonBox width={240} height={240} style={{ borderRadius: 12 }} />
            </UserInfoCell>
          </UserInfoRow>
        </SectionCard>

        {/* Menu Grid Skeleton */}
        <MenuGrid>
          {[1, 2, 3, 4].map((item) => (
            <MenuButtonSkeleton key={item}>
              <SkeletonBox width={32} height={32} style={{ marginBottom: 12 }} />
              <SkeletonText width={80} size="md" />
            </MenuButtonSkeleton>
          ))}
        </MenuGrid>

        {/* Possible Subscription Button Skeleton */}
        {/* <SkeletonBox width="100%" height={60} style={{ marginTop: 16, borderRadius: 20 }} /> */}
      </ProfileCard>
    </ContentWrapper>
  );
}

export default ProfilePageSkeleton;
